import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { PERSON_TYPE, COMPANY_TYPE, DEAL_TYPE } from 'components/BusinessCard/constants'

import { useBusinessCard } from 'components/BusinessCard/context'
import { getCurrentAccountSelector } from 'selectors/index'
import { getDealCustomFieldLabels, getPersonCustomFieldLabels, getCompanyCustomFieldLabels } from 'selectors/Account'
import { Section } from './StyledComponents'
import { H6, P } from '@PipelineDeals/shared-react-components'
import customFieldRenderer from 'customFieldRenderer'

const CustomField = ({ field }) => {
  const [showMoreHash, setShowMoreHash] = useState({})
  const { resource, currentUser, resourceType, cardMeta: { showEmptyFields } } = useBusinessCard()
  const currentAccount = useSelector(getCurrentAccountSelector)

  const customFields = {
    [DEAL_TYPE]: useSelector(getDealCustomFieldLabels),
    [PERSON_TYPE]: useSelector(getPersonCustomFieldLabels),
    [COMPANY_TYPE]: useSelector(getCompanyCustomFieldLabels)
  }

  const customFieldsType = customFields[resourceType]

  if (!customFieldsType) return null

  const customFieldLabel = customFieldsType.find(customFieldLabel => `custom_label_${customFieldLabel.id}` === field)

  if (!customFieldLabel) return null

  const value = resource.custom_fields[field]

  if (!showEmptyFields && !value && value !== false) return null
  if (!showEmptyFields && Array.isArray(value) && !value.length) return null

  const customFieldLabelValue = customFieldRenderer({
    customFieldLabel,
    customFields: resource.custom_fields,
    currency_id: resource.currency_id,
    currentAccount,
    currentUser,
    setShowMoreHash,
    showMoreHash
  })

  if (!showEmptyFields && (!customFieldLabelValue || customFieldLabelValue === '' || (Array.isArray(customFieldLabelValue) && !customFieldLabelValue.length))) return null

  return (
    <Section>
      <H6>{customFieldLabel.name}</H6>
      <P>{customFieldLabelValue}</P>
    </Section>
  )
}

CustomField.propTypes = {
  field: PropTypes.string
}

export default CustomField
